<template>
  <div>
    <AllCases
      :selectedStatuses="statuses"
      :selectedReportStatus="reportStatus"
    ></AllCases>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const AllCases = defineAsyncComponent(() =>
  import("@/components/cases/AllCases")
);
export default {
  components: {
    AllCases,
  },
  data() {
    return {
      statuses: ["COMPLETE"],
      reportStatus: true,
    };
  },
};
</script>
